'use strict';

var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;

var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));

var _toConsumableArray2 = _interopRequireDefault(require('@babel/runtime/helpers/toConsumableArray'));

var _react = _interopRequireWildcard(require('react'));

var _lodash = _interopRequireDefault(require('lodash'));

var _reactComponents = require('../../../react-components');

var _styledComponents = _interopRequireDefault(require('styled-components'));

var handleChange = function handleChange(props) {
    var value = props.value,
        index = props.index,
        onChange = props.onChange,
        setSubStrings = props.setSubStrings,
        subStrings = props.subStrings,
        connector = props.connector,
        subFilter = props.subFilter,
        setErrors = props.setErrors,
        composition = props.composition;

    if ((value <= 99 && value > 0) || !value) {
        subStrings[index] = value;
        var str = '';
        subStrings.forEach(function(sub) {
            if (sub) str = str + ''.concat(sub);
            else str = str + ''.concat(connector);
        });
        setSubStrings((0, _toConsumableArray2['default'])(subStrings));

        var numOfValidSubStrings = _lodash['default'].filter(subStrings, undefined).length;

        var numOfInputs = _lodash['default'].filter(composition, ['component', 'input']).length;

        if (numOfValidSubStrings === numOfInputs) {
            onChange({
                value: subFilter.name,
                subQuery: str,
            });
            setErrors(
                subStrings.map(function() {
                    return false;
                }),
            );
        } else {
            var errors = subStrings.map(function(sub, i) {
                if (!sub && composition[i].component === 'input') return true;
                return false;
            });
            onChange(undefined);
            setErrors(errors);
        }
    }
};

var composeSubStrings = function composeSubStrings(value, composition) {
    var connectors = '';
    composition.forEach(function(comp) {
        if (comp.connector) connectors = connectors + comp.connector;
    });
    var reg = new RegExp('['.concat(connectors, ']'));
    var values = value.split(reg);
    var count = 0;
    return composition.map(function(comp, i) {
        if (comp.component === 'input') {
            var _value = values[count];
            count = count + 1;
            return _value;
        }

        return undefined;
    });
};

var MultiInput = function MultiInput(_ref) {
    var _onChange = _ref.onChange,
        composition = _ref.composition,
        subFilter = _ref.subFilter,
        value = _ref.value,
        error = _ref.error;

    var _useState = (0, _react.useState)(Array(composition.length)),
        _useState2 = (0, _slicedToArray2['default'])(_useState, 2),
        subStrings = _useState2[0],
        setSubStrings = _useState2[1];

    var _useState3 = (0, _react.useState)(Array(composition.length)),
        _useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
        errors = _useState4[0],
        setErrors = _useState4[1];

    (0, _react.useEffect)(
        function() {
            if (value && value.subQuery) {
                setSubStrings(composeSubStrings(value.subQuery, composition));
            }
        },
        [value],
    );
    (0, _react.useEffect)(function() {
        var arr = subStrings;
        var err = errors;
        composition.forEach(function(comp, i) {
            if (comp['default']) arr[i] = comp['default'];
            else arr[i] = undefined;
            err[i] = false;
        });
        setSubStrings(arr);
        setErrors(err);
    }, []);
    (0, _react.useEffect)(
        function() {
            if (error) {
                var _errors = subStrings.map(function(sub, i) {
                    if (!sub && composition[i].component === 'input') return true;
                    return false;
                });

                setErrors(_errors);
            }
        },
        [error],
    );
    return /*#__PURE__*/ _react['default'].createElement(
        MultiInputContainer,
        null,
        composition.map(function(comp, i) {
            if (comp.component === 'input') {
                var _value2 = subStrings[i] || comp['default'];

                if (comp.type === 'number') _value2 = parseInt(_value2);
                return /*#__PURE__*/ _react['default'].createElement(_reactComponents.Input, {
                    key: 'input-'.concat(i),
                    className: 'subField-input ' + comp.id + (errors[i] && ' error'),
                    type: comp.type,
                    width: comp.type === 'number' && '3.5rem',
                    placeholder: comp.placeholder,
                    optional: true,
                    onError: function onError(e) {
                        return console.log(e);
                    },
                    onChange: function onChange(e) {
                        return handleChange({
                            value: e.target.value,
                            index: i,
                            onChange: _onChange,
                            setSubStrings: setSubStrings,
                            subStrings: subStrings,
                            connector: comp.connector,
                            subFilter: subFilter,
                            setErrors: setErrors,
                            composition: composition,
                        });
                    },
                    value: _value2,
                });
            } else if (comp.component === 'icon')
                return /*#__PURE__*/ _react['default'].createElement('i', {
                    className: comp.value,
                    key: 'icon-'.concat(i),
                });
        }),
    );
};

var MultiInputContainer = _styledComponents['default'].div.withConfig({
    displayName: 'MultiInput__MultiInputContainer',
    componentId: 'sc-168kyvb-0',
})([
    "display:flex;align-items:center;margin-right:1rem;input.error{border:1px solid #ff5722;&::placeholder{color:#ff5722;}}input{background-color:#ffffff;text-align:center;}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}input[type='number']{-moz-appearance:textfield;}i{text-align:center;width:1.25rem;color:#b9bbc1;}.details-container{display:none !important;}",
]);

var _default = MultiInput;
exports['default'] = _default;
